import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import config from '../../config'

import {
  IGetPutRequest,
  IUseUpdateMutation,
  IUpdateFn,
  ISafetyCaseAction,
  ISafetyCaseActionUpsert,
} from '../../interfaces'

const getUpdateSafetyCaseActionMutationRequest: IGetPutRequest = () => ({
  method: 'put',
  url: `${config.baseUrl}/sms/SafetyCaseActions`,
})

const useUpdateSafetyCaseActionMutation: IUseUpdateMutation<ISafetyCaseAction, ISafetyCaseActionUpsert> = (
  params,
  options = {},
) => {
  const request = useMemo(() => getUpdateSafetyCaseActionMutationRequest(params), [params])

  const updateSafetyCaseAction: IUpdateFn<ISafetyCaseActionUpsert, ISafetyCaseAction> = useCallback(
    async data => axios({ ...request, data }).then(res => res.data),
    [request],
  )

  const response = useMutation<ISafetyCaseAction, Error, ISafetyCaseActionUpsert>({
    mutationFn: updateSafetyCaseAction,
    ...options,
  })

  return response
}

export default useUpdateSafetyCaseActionMutation
